'use client';

import { ReactNode } from 'react';

import {
  EntityTab,
  EntityTabContent,
  EntityTabList,
  EntityTabProvider,
  EntityTabTrigger,
} from '@/app/(main)/(pages)/_components/entities/entity-tab.component';
import { EntitySectionDivider } from '@/app/(main)/(pages)/_components/entities/entity-section-divider.component';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface TabPartnerProps {
  about: ReactNode;
  rating: ReactNode;
  professionals?: ReactNode;
  schedules?: ReactNode;
}

export function TabPartner({ about, rating, professionals, schedules }: TabPartnerProps) {
  return (
    <EntityTabProvider>
      <EntityTab defaultValue="about" tabs={['about', 'rating']}>
        <EntityTabList className="sticky top-0 bg-white pt-2 pb-4">
          <EntityTabTrigger value="about" data-analytics-event={AnalyticsEnum.CLICK_PARTNER_ABOUT_TAB}>
            Sobre
          </EntityTabTrigger>
          <EntityTabTrigger value="rating" data-analytics-event={AnalyticsEnum.CLICK_PARTNER_REVIEW_TAB}>
            Avaliações
          </EntityTabTrigger>
        </EntityTabList>

        <div>
          <EntityTabContent value="about">
            {about}

            {professionals}
            {schedules}
          </EntityTabContent>

          <EntityTabContent value="rating">
            <EntitySectionDivider />
            {rating}
          </EntityTabContent>
        </div>
      </EntityTab>
    </EntityTabProvider>
  );
}
